import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class NotFoundService {
    private is404 = new BehaviorSubject<boolean>(false);
    is404Active$ = this.is404.asObservable();

    constructor() {}

    activate404(): void {
        this.is404.next(true);
    }

    deactivate404(): void {
        this.is404.next(false);
    }
}
